import React from "react";
import ReactHtmlParser from "react-html-parser";
import Products from "../Shared/Products";

const BrandSections = ({ brands, brandCopy, products }) =>
  [...brands].sort().map((brand) => {
    const brandProducts = products.filter(
      (product) => product.filters.Brand === brand,
    );
    if (brandProducts.length === 0) return null;

    return (
      <section className="brand-section" key={brand}>
        {brandCopy[brand] && (
          <>
            <div className="title">
              <h2 className="brand-title">{brand}</h2>
            </div>
            <div className="brand-copy">
              {ReactHtmlParser(brandCopy[brand])}
            </div>
          </>
        )}
        <Products products={brandProducts} />
      </section>
    );
  });

export default BrandSections;
